export const ADDITION = 0;
export const SUBTRACTION = 1;
export const DIFFERENCE = 3;
export const INTERSECTION = 4;
